<template>
  <div class="legal">
    <div class="legal-content">
      <div class="page-title">{{ $t('pageTitle.legal') }}</div>
      <div class="legal-menu">
        <div @click="show('imprint')" :class="{'selected' : page == 'imprint'}">{{$t('legal.imprint')}}</div>
        <div @click="show('privacy')" :class="{'selected' : page == 'privacy'}">{{$t('legal.privacy')}}</div>
        <div @click="show('terms')" :class="{'selected' : page == 'terms'}">{{$t('legal.terms')}}</div>
        <div @click="show('licences')" :class="{'selected' : page == 'licences'}">{{$t('legal.licenses')}}</div>
      </div>
      <div class="legal-wrapper">
        <div  v-if="page=='imprint'">
          <h1>{{ $t('legal.imprint') }}</h1>
          <ImprintComponent/>
        </div>

        <div  v-if="page=='privacy'">
          <h1>{{ $t('legal.privacy') }}</h1>
          <PrivacyComponent v-if="page=='privacy'"/>
        </div>
        <div  v-if="page=='terms'">
          <h1>{{ $t('legal.terms') }}</h1>
          <TermsOfUsageComponent v-if="page=='terms'"/>
        </div>
        <div  v-if="page=='licences'">
          <h1>{{ $t('legal.licenses') }}</h1>
          <pre v-if="page=='licences'">{{getLicenseText()}}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console, no-alert */

import TermsOfUsageComponent from '@/components/TermsOfUsageComponent.vue';
import ImprintComponent from '@/components/ImprintComponent.vue';
import PrivacyComponent from '@/components/PrivacyComponent.vue';
import licenseText from '@/helpers/licenses';

export default {
  name: 'SettingsView',
  components: {
    TermsOfUsageComponent,
    ImprintComponent,
    PrivacyComponent,
  },
  props: [],
  data() {
    return {
      page: 'imprint',
    };
  },
  methods: {
    show(page) {
      this.page = page;
    },
    getLicenseText() {
      return licenseText.licenseText;
    },
  },
};
</script>
<style scoped>
@import url('../styles/tiles.module.css');

.tiles-wrapper {
  padding-bottom: 0px;
}
.legal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}
.legal-wrapper {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.legal-menu {
  display: flex;
  column-gap: 32px;
}

.legal-menu div {
  border-radius: 8px;
  border: 1px solid var(--color_brown);
  padding: 8px;
}

.legal-menu div:hover {
  cursor: pointer;
  text-decoration: underline;
}

.legal-menu div.selected {
  background-color: var(--color_brown);
  color: white;
  text-decoration: none;
  font-weight: normal;
}

.legal-menu div.selected:hover {
  cursor: default;
}
</style>
